import React, { useEffect, useState } from 'react';
import { rbsApi } from '../api/rbsApi';

export const useAxios = (url) => {

    const [state, setState] = useState({
        data: null,
        isLoading: false,
        error: null
    });

    const getAxios = async () => {

        setState(prev => ({
            ...prev,
            isLoading: true
        }));

        rbsApi.get(url)

            .then(({ data }) => {

                setState({
                    data: data,
                    isLoading: false,
                    error: null,
                });

            })

            .catch((error) => {

                setState({
                    data: null,
                    isLoading: false,
                    error: error,
                });

            });
    };

    useEffect(() => {

        if (!url) {

            setState(prev => ({
                ...prev,
                isLoading: false
            }));

            return;
        }

        getAxios();

    }, [url]);

    return {
        data: state.data,
        isLoading: state.isLoading,
        error: state.error
    };
};

export const useAxios2 = (url) => {

    const [state, setState] = useState({
        data: null,
        isLoading: false,
        error: null
    });

    const getAxios = async () => {

        setState(prev => ({
            ...prev,
            isLoading: true
        }));

        rbsApi.get(url)

            .then(({ data }) => {

                setState({
                    data: data,
                    isLoading: false,
                    error: null,
                });

            })

            .catch((error) => {

                setState({
                    data: null,
                    isLoading: false,
                    error: error,
                });

            });
    };

    useEffect(() => {

        if (!url) {

            setState(prev => ({
                ...prev,
                isLoading: false
            }));

            return;
        }

        getAxios();

    }, [url]);

    return {
        dataS: state.data,
        isLoadingS: state.isLoading,
        error: state.error
    };
};

export const useAxios3 = (url) => {

    const [state, setState] = useState({
        data2: null,
        isLoading2: false,
        error2: null
    });

    const getAxios = async () => {

        setState(prev => ({
            ...prev,
            isLoading2: true
        }));

        rbsApi.get(url)

            .then(({ data }) => {

                setState({
                    data2: data,
                    isLoading2: false,
                    error2: null,
                });

            })

            .catch((error) => {

                setState({
                    data2: null,
                    isLoading2: false,
                    error2: error,
                });

            });
    };

    useEffect(() => {

        if (!url) {

            setState(prev => ({
                ...prev,
                isLoading2: false
            }));

            return;
        }

        getAxios();

    }, [url]);

    return {
        data2: state.data2,
        isLoading2: state.isLoading2,
        error2: state.error2
    };
};